import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IBugReport } from '@shared/components/bug-report/bug-report.interface';

export interface IImageZoomDialogData {
  feedback: IBugReport;
  imageUrl: string;
}

@Component({
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  selector: 'app-image-zoom-dialog',
  template: `
    <div class="flex h-full w-full">
      <div class="flex flex-1 items-center justify-center overflow-auto">
        <img [src]="data.imageUrl" [alt]="data.feedback.message" class="max-h-full max-w-full" />
      </div>
    </div>
  `,
})
export class ImageZoomDialogComponent {
  public readonly data = inject<IImageZoomDialogData>(MAT_DIALOG_DATA);
}
